const mapping: Record<string, string> = {
  id: 'u=>u.Id',
  name: 'u=>u.Name',
}

export const mapSortTicketImportUpdateParam = (key: string) => mapping[key]
